// extracted by mini-css-extract-plugin
export var cartContainer = "_g9-4";
export var gray = "_g9-1";
export var itemContainer = "_g9-2";
export var itemDetails = "_g9-3";
export var strong = "_g9-0";